module.exports = __webpack_public_path__ + "static/media/tickimage.ea797388.jpg";